export const downloadFileOnDisk = async (url: string, filename: string) => {
  const fileResponse = await fetch(url);
  const blob = await fileResponse.blob();

  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  document.body.appendChild(link);
  link.click();

  document.body.removeChild(link);
  URL.revokeObjectURL(link.href);
};
